import './SearchFacet.css';
import { Link } from 'react-router-dom';
import { Icon, close } from '../Icon/Icon';
import { getColorForCategory, stripFacetCategory } from '../../components/utils';

type SearchFacetProps = { text: string; removeUrl: string };
export const SearchFacet = ({ text, removeUrl }: SearchFacetProps) => {
	return (
		<search-facet style={{ backgroundColor: `var(${getColorForCategory(text)})` }}>
			{stripFacetCategory(text)}{' '}
			<Link className="discard" to={removeUrl}>
				<Icon shape={close} />
			</Link>
		</search-facet>
	);
};
